export default "__VITE_ASSET__BnkaYh1i__"